var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectors2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 852,
    height: 852,
    viewBox: "0 0 852 852",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4022 425.265C27.4022 373.017 37.6932 321.28 57.6877 273.009C77.6821 224.738 106.988 180.878 143.933 143.933C180.878 106.989 224.738 77.6822 273.009 57.6877C321.28 37.6933 373.017 27.4023 425.265 27.4023C477.513 27.4023 529.249 37.6933 577.52 57.6877C625.791 77.6822 669.651 106.989 706.596 143.933C743.541 180.878 772.847 224.738 792.841 273.009C812.836 321.28 823.127 373.017 823.127 425.265L425.265 425.265L27.4022 425.265Z",
    fill: "url(#paint0_linear_61_31)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M823.127 425.264C823.127 477.512 812.836 529.248 792.842 577.519C772.847 625.79 743.541 669.65 706.596 706.595C669.651 743.54 625.791 772.846 577.52 792.841C529.249 812.835 477.513 823.126 425.265 823.126C373.017 823.126 321.28 812.835 273.009 792.841C224.739 772.846 180.878 743.54 143.934 706.595C106.989 669.65 77.6823 625.79 57.6878 577.519C37.6934 529.248 27.4023 477.512 27.4023 425.264L425.265 425.264L823.127 425.264Z",
    fill: "url(#paint1_linear_61_31)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_31",
    x1: 179.045,
    y1: 458.057,
    x2: 203.363,
    y2: 230.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_61_31",
    x1: 424.776,
    y1: 774.078,
    x2: 699.776,
    y2: 425.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectors2);
export default __webpack_public_path__ + "static/media/sectors-2.bd9d9d196adcf109b9df73d5029968e0.svg";
export { ForwardRef as ReactComponent };